import { FaArrowLeft } from "react-icons/fa";
import Footer from "./Footer";
import Header from "./header";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const styles = {
  input: {
    width: "100%",
    padding: "10px",
    marginBottom: "12px",
    borderRadius: "8px",
    border: "1px solid #CBD5E1",
  },

  textarea: {
    width: "100%",
    padding: "10px",
    marginBottom: "12px",
    borderRadius: "8px",
    border: "1px solid #CBD5E1",
    resize: "none",
  },

  pageWrapper: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    width: "100%",
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    background: "#FFFFFF",
    overflowX: "hidden",
  },
  container: {
    width: "80%",
    maxWidth: "1600px",
    margin: "0 auto",
    padding: "40px 0",
    boxSizing: "border-box",
    animation: "fadeIn 0.5s ease-out forwards",
    flex: "1",
    marginTop: "50px",
  },
  breadcrumb: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "14px",
    color: "#64748B",
    marginBottom: "25px",
    flexWrap: "wrap",
  },
  backBtn: {
    background: "white",
    border: "1px solid #E2E8F0",
    padding: "8px 14px",
    borderRadius: "8px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontWeight: "600",
    color: "#475569",
    transition: "0.2s",
  },
  grid: { display: "grid", gap: "60px", alignItems: "start" },
  imageSection: { position: "sticky", top: "100px" },
  mainImageWrapper: {
    width: "100%",
    aspectRatio: "1/1",
    background: "white",
    borderRadius: "24px",
    border: "1px solid #F1F5F9",
    position: "relative",
    overflow: "hidden",
    cursor: "crosshair",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "20px",
    boxShadow: "0 10px 30px -10px rgba(0,0,0,0.05)",
  },
  mainImage: {
    width: "90%",
    height: "90%",
    objectFit: "contain",
    transition: "transform 0.1s ease-out",
    pointerEvents: "none",
  },
  thumbGrid: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  thumb: {
    width: "70px",
    height: "70px",
    borderRadius: "12px",
    border: "1px solid #E2E8F0",
    cursor: "pointer",
    padding: "4px",
    background: "white",
    transition: "0.2s",
    objectFit: "contain",
  },
  thumbActive: {
    borderColor: "#D60000",
    transform: "translateY(-2px)",
    boxShadow: "0 4px 10px rgba(214, 0, 0, 0.2)",
  },
  brandBadge: {
    background: "#FEF2F2",
    color: "#D60000",
    padding: "6px 12px",
    borderRadius: "30px",
    fontSize: "11px",
    fontWeight: "800",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    width: "fit-content",
    marginBottom: "15px",
  },
  title: {
    fontSize: "36px",
    fontWeight: "800",
    color: "#0F172A",
    lineHeight: "1.2",
    marginBottom: "15px",
  },
  priceBlock: {
    display: "flex",
    alignItems: "baseline",
    gap: "12px",
    marginBottom: "25px",
    paddingBottom: "25px",
    borderBottom: "1px solid #F1F5F9",
    flexWrap: "wrap",
  },
  price: { fontSize: "42px", fontWeight: "800", color: "#0F172A" },
  mrp: {
    fontSize: "20px",
    textDecoration: "line-through",
    color: "#94A3B8",
    fontWeight: "500",
  },
  discountTag: {
    background: "#DCFCE7",
    color: "#166534",
    padding: "4px 8px",
    borderRadius: "4px",
    fontSize: "12px",
    fontWeight: "bold",
  },
  configHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "15px",
  },
  configLabel: {
    fontSize: "13px",
    fontWeight: "700",
    color: "#64748B",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  moqBadge: {
    fontSize: "12px",
    fontWeight: "700",
    color: "#B91C1C",
    background: "#FEF2F2",
    padding: "4px 10px",
    borderRadius: "6px",
    border: "1px solid #FECACA",
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  configGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))",
    gap: "15px",
    marginBottom: "30px",
  },
  configCard: {
    border: "1px solid #E2E8F0",
    borderRadius: "16px",
    padding: "20px 10px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    position: "relative",
    background: "white",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    alignItems: "center",
    textAlign: "center",
  },
  configActive: {
    borderColor: "#D60000",
    background: "#FFF5F5",
    boxShadow: "0 0 0 1px #D60000",
    transform: "translateY(-2px)",
  },
  confName: {
    fontSize: "15px",
    fontWeight: "700",
    color: "#0F172A",
    lineHeight: "1.3",
  },
  confPrice: { fontSize: "15px", color: "#D60000", fontWeight: "800" },
  checkIcon: {
    position: "absolute",
    top: "8px",
    right: "8px",
    color: "#D60000",
    fontSize: "14px",
    background: "white",
    borderRadius: "50%",
  },
  actionArea: {
    display: "flex",
    gap: "15px",
    marginTop: "20px",
    marginBottom: "30px",
    alignItems: "stretch",
    flexWrap: "wrap",
  },
  qtyBox: {
    display: "flex",
    alignItems: "center",
    background: "#F8FAFC",
    borderRadius: "12px",
    border: "1px solid #E2E8F0",
    padding: "0 5px",
  },
  qtyBtn: {
    width: "40px",
    height: "100%",
    background: "transparent",
    border: "none",
    fontSize: "14px",
    cursor: "pointer",
    color: "#475569",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  qtyVal: {
    width: "30px",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "18px",
    color: "#0F172A",
  },
  cartBtn: {
    flex: 1,
    background: "#D60000",
    color: "white",
    border: "none",
    borderRadius: "14px",
    fontSize: "18px",
    fontWeight: "700",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    boxShadow: "0 8px 20px -5px rgba(214, 0, 0, 0.4)",
    transition: "0.2s",
    padding: "16px",
    minWidth: "200px",
  },
  trustGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "20px",
    background: "#F8FAFC",
    padding: "25px",
    borderRadius: "20px",
    border: "1px solid #E2E8F0",
  },
  trustItem: { display: "flex", gap: "12px", alignItems: "flex-start" },
  trustIcon: {
    color: "#D60000",
    fontSize: "22px",
    marginTop: "2px",
    flexShrink: 0,
  },
  trustTitle: {
    fontSize: "13px",
    fontWeight: "700",
    color: "#0F172A",
    lineHeight: "1.4",
  },
  trustSub: { fontSize: "12px", color: "#64748B" },
  tabs: {
    display: "flex",
    gap: "40px",
    borderBottom: "2px solid #F1F5F9",
    marginTop: "60px",
    marginBottom: "40px",
    overflowX: "auto",
    paddingBottom: "2px",
  },
  tabItem: {
    paddingBottom: "15px",
    cursor: "pointer",
    fontWeight: "600",
    color: "#94A3B8",
    position: "relative",
    fontSize: "16px",
    background: "none",
    border: "none",
    whiteSpace: "nowrap",
    transition: "0.2s",
  },
  tabActive: {
    color: "#D60000",
    borderBottom: "3px solid #D60000",
    marginBottom: "-2px",
  },
  specContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: "30px",
  },
  specCard: {
    background: "white",
    padding: "30px",
    borderRadius: "20px",
    border: "1px solid #E2E8F0",
    boxShadow: "0 4px 10px rgba(0,0,0,0.02)",
  },
  specHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "25px",
    paddingBottom: "15px",
    borderBottom: "2px solid #F1F5F9",
  },
  specIconBox: {
    width: "40px",
    height: "40px",
    borderRadius: "10px",
    background: "#FEF2F2",
    color: "#D60000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
  },
  specTitle: { fontSize: "17px", fontWeight: "800", color: "#0F172A" },
  specRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "14px",
    fontSize: "14px",
    borderBottom: "1px dashed #F1F5F9",
    paddingBottom: "10px",
  },
  specLabel: {
    color: "#64748B",
    fontWeight: "600",
    textTransform: "capitalize",
  },
  specValue: { fontWeight: "700", color: "#334155", textAlign: "right" },
  card: {
    background: "white",
    padding: "35px",
    borderRadius: "24px",
    border: "1px solid #F1F5F9",
    marginBottom: "20px",
  },
  reviewCard: {
    borderBottom: "1px solid #F1F5F9",
    paddingBottom: "25px",
    marginBottom: "25px",
  },
  reviewHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "10px",
  },
  reviewUser: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontWeight: "700",
    color: "#334155",
  },
};

const PrivacyPolicy = ({ onBack }) => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Privacy Policy | CGRMART</title>

        <meta
          name="description"
          content="Read Tucker EV Charging Privacy Policy. Learn how we collect, use, and protect your personal data securely."
        />

        <meta
          name="keywords"
          content="privacy policy, EV charging, Tucker, data protection, EV platform"
        />

        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta property="og:title" content="Privacy Policy | CGRMART" />
        
        <meta
          property="og:description"
          content="Understand how Tucker protects your personal data and privacy."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://cgrmart.com/privacy-policy" />

        {/* Twitter */}
        <meta name="twitter:title" content="Privacy Policy | Tucker EV" />
        <meta
          name="twitter:description"
          content="Tucker EV privacy and data protection policy."
        />

        {/* Canonical */}
        <link rel="canonical" href="https://cgrmart.com/privacy-policy" />
      </Helmet>

      <Header />
      <div style={styles.pageWrapper}>
        <div style={styles.container}>
          <div style={styles.breadcrumb}>
            <button
              onClick={() => {
                navigate("/");
              }}
              style={styles.backBtn}
            >
              <FaArrowLeft /> Back
            </button>
          </div>
          <div className="max-w-4xl mx-auto p-6 text-gray-800">
            <h1 className="text-3xl font-bold mb-2">Privacy Policy</h1>
            <p className="mb-6 text-sm text-gray-500">
              Effective Date: 21 March 2026
            </p>

            <h2 className="text-xl font-semibold mt-4 mb-2">1. Introduction</h2>
            <p className="mb-4">
              Tucker is committed to ensuring the protection, confidentiality,
              and security of personal data. This Privacy Policy sets out the
              principles governing the collection, use, processing, storage, and
              safeguarding of personal information in connection with its
              electric vehicle charging products, digital platforms, websites,
              mobile applications, and related services.
            </p>
            <p className="mb-4">
              By accessing or using our services, you consent to the collection
              and processing of your personal data in accordance with this
              Policy and applicable laws.
            </p>

            <p className="mb-4">This policy applies to:</p>
            <ul className="list-disc pl-6 mb-4 space-y-1">
              <li>Customers and End Users</li>
              <li>Charge Point Operators (CPOs)</li>
            </ul>

            <h2 className="text-xl font-semibold mt-6 mb-2">
              2. Data We Collect
            </h2>
            <p className="mb-2">
              We may collect the following categories of data:
            </p>

            <h3 className="font-semibold mt-3">
              2.1 Personal Identification Information
            </h3>
            <ul className="list-disc pl-6 mb-3">
              <li>
                Name, contact details, email address, and address details.
              </li>
            </ul>

            <h3 className="font-semibold mt-3">2.2 Vehicle & Charging Data</h3>
            <ul className="list-disc pl-6 mb-3">
              <li>
                Vehicle details, charging preferences, session data (time,
                energy consumed, tariff), and usage patterns.
              </li>
            </ul>

            <h3 className="font-semibold mt-3">
              2.3 Account & Transaction Data
            </h3>
            <ul className="list-disc pl-6 mb-3">
              <li>
                User account details, transaction history, billing information,
                and invoices.{" "}
              </li>
              <li>
                Payment details are processed securely through authorised
                payment gateways and are not stored by the Company.
              </li>
            </ul>

            <h3 className="font-semibold mt-3">2.4 Technical Data</h3>
            <ul className="list-disc pl-6 mb-3">
              <li>
                Device information, IP address, application usage, and location
                data (where applicable).
              </li>
            </ul>
            <h2 className="text-xl font-semibold mt-6 mb-2">
              3. Purpose of Data Processing
            </h2>
            <p>
              We process personal data for legitimate business purposes,
              including:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-1">
              <li>Provision and operation of EV charging services </li>
              <li> Billing, invoicing, and transaction processing </li>
              <li> Customer support and service communication </li>
              <li> Service improvement and analytics </li>
              <li>
                {" "}
                Fraud prevention, security, and compliance with legal
                obligations{" "}
              </li>
            </ul>

            <h2 className="text-xl font-semibold mt-6 mb-2">
              4. Data Sharing and Disclosure
            </h2>
            <p>Personal data may be shared with:</p>
            <ul className="list-disc pl-6 mb-4 space-y-1">
              <li>
                {" "}
                Authorised service providers (payment processors, cloud
                services, technical support){" "}
              </li>
              <li>
                {" "}
                Business partners and operators involved in service
                delivery{" "}
              </li>
              <li>
                {" "}
                Government or regulatory authorities, where required by law{" "}
              </li>
            </ul>
            <p className="mb-4">
              The Company does not sell or rent personal data to third parties.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">
              5. Data Security
            </h2>
            <p>
              We implement appropriate technical and organisational measures to
              protect personal data, including:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-1">
              <li> Secure data encryption and transmission </li>
              <li> Controlled access to sensitive information </li>
              <li> Periodic security audits and system monitoring </li>
            </ul>

            <h2 className="text-xl font-semibold mt-6 mb-2">
              6. Data Retention
            </h2>
            <p>
              Personal data shall be retained only for as long as necessary for
              business, legal, or regulatory purposes:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-1">
              <li> Customer data: Up to 3 years or as required by law </li>
              <li>
                {" "}
                Charging and transaction records: As per regulatory
                requirements{" "}
              </li>
              <li>
                Payment data: Not stored (only transaction references
                maintained){" "}
              </li>
            </ul>

            <h2 className="text-xl font-semibold mt-6 mb-2">7. User Rights</h2>
            <p>Subject to applicable law, users have the right to:</p>
            <ul className="list-disc pl-6 mb-4 space-y-1">
              <li> Access and review their personal data </li>
              <li> Request correction or deletion of data </li>
              <li> Withdraw consent for data processing </li>
            </ul>
            <p className="mb-4">
              Requests may be submitted via: support@tuckermotors.com
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">
              8. Cookies and Tracking
            </h2>
            <p>
              Our platforms may use cookies and similar technologies to enhance
              user experience, analyse usage patterns, and improve services.
              Users may control cookie preferences through their browser
              settings.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">
              9. Legal Compliance and Jurisdiction
            </h2>
            <p className="mb-4">
              This Privacy Policy is governed by the applicable laws of India,
              including the Information Technology Act, 2000 and relevant data
              protection regulations.
            </p>
            <p className="mb-4">
              Any disputes arising out of or in connection with this Policy
              shall be subject to the exclusive jurisdiction of the courts in
              Madurai, Tamil Nadu, India.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">10. Amendments</h2>
            <p className="mb-4">
              The Company reserves the right to update or modify this Privacy
              Policy at any time. Continued use of services shall constitute
              acceptance of the revised Policy.
            </p>
            <h2 className="text-xl font-semibold mt-6 mb-2">
              11. Contact Information
            </h2>
            <p className="mb-4">
              For any queries or concerns regarding this Privacy Policy, please
              contact Email: support@tuckermotors.com
            </p>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default PrivacyPolicy;
